export default {
    //是否显示弹窗
    getCenterDialogVisible(state) {
        return state.centerDialogVisible;
    },
    //显示什么弹窗
    getModalStatus(state) {
        return state.modalStatus;
    },
    //是否显示返回上一级
    getIsReturn(state) {
        return state.is_return;
    },
    //滚轮状态
    getScrollType(state) {
        return state.scrollType;
    },
    //登录状态
    getloginType(state) {
        return state.is_login;
    },
    //个人中心侧边栏选择
    get_user_nav_active(state) {
        return state.user_nav_active;
    },
    //登录用户资料
    get_login_user_data(state) {
        return state.login_user;
    },
    //学员弹窗显示 babyModal.vue,
    get_babyModal_visible(state) {
        return state.babyModalVisible;
    },
    //学员弹窗表单 babyModal.vue,
    get_babyModal_form(state) {
        return state.babyModalForm;
    },
    //报名弹窗监控
    get_courseEnter_visible(state) {
        return state.courseEnterVisible;
    },
    //修改学校信息资料
    get_schoolInformation(state) {
        return state.schoolInformation;
    },
    //监听搜索字段
    getSearchVal(state) {
        return state.SearchVal;
    },
    //floatbar底部active状态页面
    getFloatBarActive(state) {
        return state.floatBarActive;
    },
}


// WEBPACK FOOTER //
// ./src/store/getters.js